import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';

export default function ModalSupervisor(props) {
  const supervisor = props.model;

  const [dataChanging, setDataChanging] = useState(supervisor);
  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value,
    });
  }

  const [zones, setZones] = useState([]);
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  useEffect(() => {
    if (!supervisor.id && supervisor.open) {
      listZones();
    }
  }, [supervisor.open]);

  return (
    <Modal
      title="Supervisor"
      model={supervisor}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="base/supervisor"
      state
    >
      <TextField
        label="Nombre"
        name="name"
        margin="normal"
        fullWidth
        defaultValue={supervisor?.name || ''}
        required
      />
      <TextField
        label="DNI"
        name="dni"
        margin="normal"
        fullWidth
        defaultValue={supervisor?.dni || ''}
        onKeyPress={(e) => {
          var key = window.event ? e.which : e.keyCode;
          if (key < 48 || key > 57) {
            return e.preventDefault();
          }
        }}
        inputProps={{
          maxLength: 8,
          minLength: 8,
        }}
        required
      />
      <TextField
        label="Correo"
        name="email"
        margin="normal"
        type="email"
        fullWidth
        defaultValue={supervisor?.user?.email || ''}
        autoComplete="off"
        inputProps={{
          autoComplete: 'off',
        }}
        required={supervisor.id === undefined}
      />

      {supervisor.id === undefined && (
        <TextField
          label="Contraseña"
          name="password"
          margin="normal"
          fullWidth
          defaultValue=""
          autoComplete="off"
          inputProps={{
            autoComplete: 'off',
          }}
          required
        />
      )}

      <TextField
        label="Celular"
        fullWidth
        type="text"
        name="phone"
        margin="normal"
        onKeyPress={(e) => {
          var key = window.event ? e.which : e.keyCode;
          if (key < 48 || key > 57) {
            return e.preventDefault();
          }
        }}
        inputProps={{
          maxLength: 9,
          minLength: 9,
        }}
        defaultValue={supervisor?.phone || ''}
      />
      {!supervisor.id && zones.length > 0 ? (
        <Autocomplete
          multiple
          disableCloseOnSelect={true}
          size="small"
          options={zones}
          getOptionLabel={(option) => option.description}
          renderInput={(params) => <TextField {...params} label="Zonas" margin="normal" />}
          onChange={(e, items) => {
            if (!!items) {
              let arr = items.map((item) => {
                return item.id;
              });
              handleChange('zones', arr);
            } else {
              handleChange('zones', null);
            }
          }}
        />
      ) : undefined}
    </Modal>
  );
}
